import React from 'react';
// logic
import { useHistory } from 'react-router-dom';
// icons
import { ReactComponent as NewIcon } from 'assets/icons/new.svg';
import { ReactComponent as FiltersIcon } from 'assets/icons/filters.svg';
import ToolBarButton from '../ui/toolbar/toolBarButton';
// components
import RegularText from '../ui/texts/RegularText';
import { PremiumInput } from '../ui/inputs/customInput';
import { STATES } from 'modules/emergencies/constants';
import ticketService from 'modules/emergencies/ticketService';
import useAlertsModal from '../modals/useAlertsModal';
import NotificationIcon from '../ui/icon/notificationIcon';
import ToolbarContainer from '../ui/containers/toolbarContainer';
import FlexContainer from '../ui/containers/flexContainer';
import styled from 'styled-components';
import { getCountryGroupOptions } from 'modules/emergencies/mappers/country-groups';
import SelectWithSearchInput from '../modals/SelectWithSearchInput';
import {
  MultiSelectInputComponent,
  FlexComponent,
  BallComponent,
  TextComponent,
} from '@ontruck/fe-ui';

const CustomFlexContainer = styled(FlexContainer)`
  height: 100%;
`;

const SmartViewsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  height: 100%; ;
`;
const SmartViewsButton = styled(ToolBarButton)`
  background-color: var(--grey200);
  height: auto;
  height: 100%; ;
`;

const SmartViewsInputContainer = styled.div`
  background-color: var(--grey200);
  padding: 8px;
  height: 100%; ;
`;

const countryGroupOptions = getCountryGroupOptions();

const stateOptions = [
  {
    value: STATES.DRAFT,
    label: 'Draft',
    color: ticketService.bussiness.colorStates.DRAFT,
    component: (
      <FlexComponent gap="10px">
        <BallComponent backgroundColor={ticketService.bussiness.colorStates.DRAFT} />
        <TextComponent>Draft</TextComponent>
      </FlexComponent>
    ),
  },
  {
    value: STATES.PENDING,
    label: 'Pending',
    color: ticketService.bussiness.colorStates.PENDING,
    component: (
      <FlexComponent gap="10px">
        <BallComponent backgroundColor={ticketService.bussiness.colorStates.PENDING} />
        <TextComponent>Pending</TextComponent>
      </FlexComponent>
    ),
  },
  {
    value: STATES.QUOTE_SENT,
    label: 'Quote sent',
    color: ticketService.bussiness.colorStates.QUOTE_SENT,
    component: (
      <FlexComponent gap="10px">
        <BallComponent backgroundColor={ticketService.bussiness.colorStates.QUOTE_SENT} />
        <TextComponent>Quote sent</TextComponent>
      </FlexComponent>
    ),
  },

  {
    value: STATES.REJECTED,
    label: 'Quote rejected',
    color: ticketService.bussiness.colorStates.REJECTED,
    component: (
      <FlexComponent gap="10px">
        <BallComponent backgroundColor={ticketService.bussiness.colorStates.REJECTED} />
        <TextComponent>Quote rejected</TextComponent>
      </FlexComponent>
    ),
  },
  {
    value: STATES.EXPIRED,
    label: 'Quote expired',
    color: ticketService.bussiness.colorStates.EXPIRED,
    component: (
      <FlexComponent gap="10px">
        <BallComponent backgroundColor={ticketService.bussiness.colorStates.EXPIRED} />
        <TextComponent>Quote expired</TextComponent>
      </FlexComponent>
    ),
  },

  {
    value: STATES.ACCEPTED,
    label: 'Accepted',
    color: ticketService.bussiness.colorStates.ACCEPTED,
    component: (
      <FlexComponent gap="10px">
        <BallComponent backgroundColor={ticketService.bussiness.colorStates.ACCEPTED} />
        <TextComponent>Accepted</TextComponent>
      </FlexComponent>
    ),
  },
  {
    value: STATES.CANCELLED,
    label: 'Cancelled',
    color: ticketService.bussiness.colorStates.CANCELLED,
    component: (
      <FlexComponent gap="10px">
        <BallComponent backgroundColor={ticketService.bussiness.colorStates.CANCELLED} />
        <TextComponent>Cancelled</TextComponent>
      </FlexComponent>
    ),
  },
  {
    value: STATES.DONE,
    label: 'Moved > Tms',
    color: ticketService.bussiness.colorStates.DONE,
    component: (
      <FlexComponent gap="10px">
        <BallComponent backgroundColor={ticketService.bussiness.colorStates.DONE} />
        <TextComponent>{'Moved > Tms'}</TextComponent>
      </FlexComponent>
    ),
  },
];

const t = {
  origin_country_code: {
    error: 'No results found, try again later',
    no_users: 'No results found',
    field_label: 'Origin',
    search_label: 'Search',
  },
  destination_country_code: {
    error: 'No results found, try again later',
    no_users: 'No results found',
    field_label: 'Destination',
    search_label: 'Search',
  },
};

const TicketsListToolbar = ({ filtersData, lastUpdate, className }) => {
  const {
    internalSelectedFilters,
    setCreatedAtAfter,
    setState,
    setSearch,
    setFiltersView,
    setOriginCountryGroup,
    setDestinationCountryGroup,
    availableFiterViewsOptions,
  } = filtersData;

  const history = useHistory();
  const { openModalAlerts } = useAlertsModal();

  return (
    <ToolbarContainer noPaddingX>
      <CustomFlexContainer>
        <SmartViewsContainer>
          <SmartViewsButton
            withBorder={true}
            onClick={() => {
              history.push('/emergencies/filter-views');
            }}
          >
            <FiltersIcon />
          </SmartViewsButton>
          <SmartViewsInputContainer>
            <PremiumInput
              label="Filter view"
              width="250px"
              value={internalSelectedFilters?.filtersView || -1}
              type={'select'}
              onChange={(option) => {
                setFiltersView(option);
                return;
              }}
              availableOptions={availableFiterViewsOptions}
            />
          </SmartViewsInputContainer>
        </SmartViewsContainer>
        {/* crated after */}
        <PremiumInput
          type="date"
          value={internalSelectedFilters.created_at_after}
          label="Created after"
          width="200px"
          onChange={(date) => {
            const newValue = date;
            setCreatedAtAfter(newValue);
          }}
          disableClear={true}
        />
        {/* state */}
        <MultiSelectInputComponent
          label="Ticket state"
          width="200px"
          options={stateOptions}
          values={internalSelectedFilters.state}
          onChange={(state) => {
            setState(state);
          }}
        />
        {/* origin country group */}
        <SelectWithSearchInput
          width="140px"
          onFieldChange={(value) => {
            if (value === '') {
              setOriginCountryGroup('');
              return;
            }
            const countryOption = countryGroupOptions.find((option) => option.value === value);
            if (countryOption) {
              setOriginCountryGroup(countryOption.value);
            }
          }}
          options={countryGroupOptions}
          value={internalSelectedFilters.origin_country_group}
          label={t.origin_country_code.field_label}
          searchLabel={t.origin_country_code.search_label}
          optionsEmptyMssg={t.origin_country_code.no_users}
          isClereable={true}
          key={'origin_country_group'}
        />

        {/* destination country group */}
        <SelectWithSearchInput
          width="140px"
          onFieldChange={(value) => {
            if (value === '') {
              setDestinationCountryGroup('');
              return;
            }
            const countryOption = countryGroupOptions.find((option) => option.value === value);
            if (countryOption) {
              setDestinationCountryGroup(countryOption.value);
            }
          }}
          options={countryGroupOptions}
          value={internalSelectedFilters.destination_country_group}
          label={t.destination_country_code.field_label}
          searchLabel={t.destination_country_code.search_label}
          optionsEmptyMssg={t.origin_country_code.no_users}
          isClereable={true}
          key={'destination_country_group'}
        />

        {/* search */}
        <PremiumInput
          onChange={(e) => {
            const newValue = e.target.value;
            setSearch(newValue);
          }}
          type="search"
          value={internalSelectedFilters.search}
          label="Search"
          width="220px"
        />
      </CustomFlexContainer>
      <FlexContainer>
        {!!lastUpdate && <RegularText>Last update: {lastUpdate}</RegularText>}

        <ToolBarButton
          withBorder={true}
          onClick={() => {
            history.push('/emergencies/new');
          }}
        >
          <NewIcon />
          New ticket
        </ToolBarButton>
        <ToolBarButton withBorder={true} onClick={openModalAlerts}>
          <NotificationIcon />
        </ToolBarButton>
      </FlexContainer>
    </ToolbarContainer>
  );
};

export default TicketsListToolbar;
